import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
    root: {
        minWidth: '300px',
        padding: '0px 30px 0px 10px',
        [theme.breakpoints.down('lg')]: {
            padding: '0px 20px',
        },
        paddingBottom: '10px',
    },
}));
